import React, { memo, useCallback } from "react";
import { Pagination } from "services/search";
import TablePagination from "ui/components/Table/TableSearch/components/TablePagination/TablePagination";

const ROW_SIZE_OPTIONS = [10, 20, 50, 100];

export interface TableGridFooterProps {
  pagination?: Pagination;
  onPaginationChange?: (pagination: Pagination) => void;
}

const TableGridFooter: React.FC<TableGridFooterProps> = ({
  pagination,
  onPaginationChange,
}) => {
  const handleChangePage = useCallback(
    (newPage: number | string) => {
      if (onPaginationChange && pagination) {
        const pageNumber = typeof newPage === "string" ? parseInt(newPage) : newPage;
        onPaginationChange({ ...pagination, pageNumber });
      }
    },
    [pagination, onPaginationChange]
  );

  const handleChangeRowsSize = useCallback(
    (value: string) => {
      if (onPaginationChange && pagination) {
        onPaginationChange({
          ...pagination,
          pageSize: parseInt(value),
          pageNumber: 1,
        });
      }
    },
    [pagination, onPaginationChange]
  );

  return (
    <TablePagination
      pagination={pagination}
      onChangePage={handleChangePage}
      rowsSizeOptions={ROW_SIZE_OPTIONS}
      onChangeRowsSize={handleChangeRowsSize}
      isMinimized={true}
    />
  );
};

export default memo(TableGridFooter);
